import { usePostMessageHandler } from '~teacher/hook/utils/usePostMessageHandler';

const DISCOVER_ORIGIN = 'https://quizshop.co';

export function useImportQuizBySocMessageListener(
  importBySoc: (socCode: string) => void
) {
  usePostMessageHandler(
    (event: MessageEvent<{ soc_code: string | number }>) => {
      if (__DEV__) {
        console.debug('origin', event.origin);
      }

      if (event.origin !== DISCOVER_ORIGIN) return; // Ignore origins that are not discover tab

      const { soc_code: socCode } = event.data;

      if (!socCode) return; // No soc code.

      if (__DEV__) {
        console.debug('soc', socCode);
      }

      importBySoc(socCode.toString());
    }
  );
}
